export function mapFromObject( obj: any, level = 1 ): Map<string, any> {
    if ( !obj ) {
        return null;
    }

    let map = new Map();
    for ( let key of Object.keys( obj ) ) {
        if ( level <= 1 ) {
            map.set( key, obj[key] );
        } else {
            map.set( key, mapFromObject( obj[key], level - 1 ) );
        }
    }
    return map;
}
